import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'

import { getTokens } from 'core/classes/helpers/StorageHelper'
import { proxy } from 'core/classes/helpers/UrlHelper'
import { HttpHeaders, Rest } from 'core/classes/http'
import Logger from 'core/utils/Logger'

import { assignUuidToBridge } from '../../bridgesData/businessBridgesTable/helpers/assignUuidToBridge'
import { IBridgeWithUuid } from '../../bridgesData/businessBridgesTable/models/iCalculatedBridge'

export interface IFetchJbpBridgesParameters {
  ownerId: string
  partnerId: string
  programType: ProgramTypes
  fYear: number
  isRollup?: boolean
  geoFilter?: string // comma separated country codes
}

export const fetchJBPBridges = async ({
  ownerId,
  partnerId,
  programType,
  fYear,
  isRollup,
  geoFilter,
}: IFetchJbpBridgesParameters): Promise<{ Data: IBridgeWithUuid[] }> => {
  const url = proxy('/webservice/621/sp/v3/spJBPBridges/call')
  const [accessToken] = getTokens(ownerId)
  const headers = new HttpHeaders()

  if (accessToken) {
    headers.add('Authorization', `Bearer ${accessToken}`)
  }

  const payload = {
    'p.PartnerId': partnerId,
    'p.ProgramType': programType,
    'p.FYear': fYear,
    'p.IsRollup': isRollup ? 1 : 0,
    'p.GeoFilter': geoFilter,
  }

  try {
    const response = await Rest.post({ url, payload, headers })
    return {
      Data: response.Rows.map(assignUuidToBridge),
    }
  } catch (e) {
    Logger.error('Error on fetch Bridges', e)
    return {
      Data: [],
    }
  }
}
